import {Button, Slide, Stack} from "@mui/material";
import {useStore} from "../../shared/context-provider/context-provider";

export const FormFeedback = () => {
  const {carStore} = useStore();
  return (
    <Slide in={true} direction={carStore.directionSlide} timeout={500}>
      <div>
        <h3 className={"widget-title"}>Thanks for contacting us! </h3>
        <div className={"widget-subtitle"}>
          We will get in touch with you shortly.
        </div>
        <Stack  direction="row" sx={{
          justifyContent: "center",
        }}>
          <Button
            onClick={carStore.completeCarWidget}
            size={'large'}
            sx={{
              paddingX: 3,
              borderRadius: 12
            }}
            variant={'contained'} color={'success'}>
            Nice
          </Button>
        </Stack>
      </div>
    </Slide>
  );
};
